import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { ILineaBaseDatosClima } from 'src/app/interface/interfaces';
import { SenaceService } from 'src/app/services/senace.service';

@Component({
  selector: 'app-linea-base',
  templateUrl: './linea-base.component.html',
  styleUrls: ['./linea-base.component.css']
})
export class LineaBaseComponent implements OnInit {
  // Estaciones Meteorológicas
  componenteEstacionesMeteorologicas = {
    titulo: 'ESTACIONES METEOROLOGICAS',
    cabecera: ['Nombre', 'Este', 'Norte', 'Zona', 'Altitud', 'Entidad'],
    filas: []
  };
  // Fuente de Agua
  componenteFuentesAgua = {
    titulo: 'FUENTE DE AGUA',
    cabecera: ['Tipo', 'Nombre', 'Categoría', 'Caudal Máximo', 'Caudal Mínimo'],
    filas: []
  };

  // Fuente de Agua
  componentePasivoAmbiental = {
    titulo: 'PASIVOS AMBIENTALES',
    cabecera: ['Nombre', 'Tipo', 'Subtipo', 'Zona', 'Norte','Este', 'Responsable', 'Ecosistema Frágil'],
    filas: []
  };
  // Estaciones de Muestreo
  componenteEstacionesMuestreo = {
    titulo: 'ESTACIONES DE MUESTREO',
    cabecera: ['Medio Evaluado', 'Nombre Estación', 'Descripcón', 'Norte', 'Este', 'Zona', 'Altitud'],
    filas: []
  };
  // Aspecto Poblacional
  componenteAspectoPoblacional = {
    titulo: 'ASPECTO POBLACIONAL',
    cabecera: ['Código INEI', 'Nombre', 'Idioma', 'Actividad Económica', 'Población Total', 'Población Masculina', 'Población Femenina', 'Número de Viviendas'],
    filas: []
  };

  datosClima: ILineaBaseDatosClima[] = [];

  constructor(
    private localStorage: LocalStorage,
    private senaceService: SenaceService
  ) { }

  ngOnInit() {
    this.localStorage.getItem('detalle')
      .subscribe(resp => {
        const datos = this.senaceService.getLineaBase(resp);
        this.getEstacionesMeteorologicas(datos);
        this.getFuentesAgua(datos);
        this.getPasivoAmbiental(datos);
        this.getEstacionesMuestreo(datos);
        this.getAspectoPoblacional(datos);
        this.getDatosClima(datos);
      })
  }

  getEstacionesMeteorologicas(resultado) {
    let data: any[] = resultado['estacionesMeteorologicas'];
    data.forEach(item => {
      let arr = [item.nombre || '', item.este || '', item.norte || '', item.zona || '', item.altitud || '', item.entidad || ''];
      this.componenteEstacionesMeteorologicas.filas.push(...[arr]);
    });
  }
  getFuentesAgua(resultado) {
    let data: any[] = resultado['fuentesAgua'];
    data.forEach(item => {
      let arr = [item.tipo || '', item.nombre || '', item.categoria || '', item.caudalMaximo || '', item.caudalMinimo || ''];
      this.componenteFuentesAgua.filas.push(...[arr]);
    });
  }

  getPasivoAmbiental(resultado) {
    let data: any[] = resultado['pasivosAmbientales'];
    data.forEach(item => {
      let arr = [item.nombre || '', item.tipo || '', item.subtipo || '', item.zona || '', item.norte || '', item.este || '', item.responsable || '', item.ecosistemaFragil || ''];
      this.componentePasivoAmbiental.filas.push(...[arr]);
    });
  }

  getEstacionesMuestreo(resultado) {
    let data: any[] = resultado['estacionesMuestreo'];
    data.forEach(item => {
      let arr = [item.medioEvaluado || '', item.nombreEstacion || '', item.descripcion || '', item.norte || '', item.este || '', item.zona || '', item.altitud || ''];
      this.componenteEstacionesMuestreo.filas.push(...[arr]);
    });
  }

  getAspectoPoblacional(resultado) {
    let data: any[] = resultado['aspectoPoblacion'];
    data.forEach(item => {
      let arr = [item.identificacionINEI || '', item.nombre || '', item.idioma || '', item.actividadEconomica || '', item.poblacionTotal || '', item.poblacionMasculina || '', item.poblacionFemenina || '', item.numeroViviendas || ''];
      this.componenteAspectoPoblacional.filas.push(...[arr]);
    });
  }

  getDatosClima(resultado) {
    let data: any[] = resultado['clima'];
    data.forEach(item => {
      this.datosClima.push(item);
    });
  }






}
